<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card title="PRODUCT DETAILS" >
          <template slot="actions">
            <vs-button v-can="'create-edit-product-name-mapping'" @click="onClickCreateDetail" class="mr-4" color="primary" type="filled">Create</vs-button>
          </template>
          <div slot="no-body" class="mt-4">
            <vs-input icon-pack="feather" icon="icon-search" placeholder="Search"
                      v-model="filters['search']"
                      class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" />
            <vs-table id="customer-site-list-table" :max-items="(meta.per_page) ? meta.per_page : 10" :data="product_detail_list"   :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th width="15%">ITS PRODUCT CODE</vs-th>
                <vs-th width="30%">ITS PRODUCT CODE</vs-th>
                <vs-th width="15%">PRODUCT CODE</vs-th>
                <vs-th width="30%">PRODUCT NAME</vs-th>
                <vs-th width="10%" >ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr @click.native="onClickCustomerSiteUpdate(data[indextr].id)" style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">


                  <vs-td :data="data[indextr].formulation_code">
                   <span style="cursor: pointer" @click.stop="viewFormulation(data[indextr])"> {{ data[indextr].formulation_code}}</span>
                  </vs-td>
                  <vs-td :data="data[indextr].formulation_name">
                    {{ data[indextr].formulation_name }}
                  </vs-td>

                  <vs-td :data="data[indextr].product_code">
                    {{ data[indextr].product_code }}
                  </vs-td>

                  <vs-td :data="data[indextr].product_name">
                    {{ data[indextr].product_name }}
                  </vs-td>


                  <vs-td>
                    <div class="vx-row">
                      <vx-tooltip text="View/Update" position="left">
                        <vs-button @click.stop="onClickCustomerSiteUpdate(data[indextr].id)"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-can="'create-edit-product-name-mapping'" class="ml-2" text="Remove" position="left">
                        <vs-button @click.stop="onClickProductDetailDelete(data[indextr].id)"
                                   size="small" color="danger" type="border" icon-pack="feather" icon="icon-trash-2"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>


            </vs-table>

          </div>
        </vx-card>
      </div>
    </div>
    <create-customer-product-details-pop-up ref="createCustomerProductDetailsPopUp"/>
    <update-customer-product-details-pop-up ref="updateCustomerProductDetailsPopUp"/>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import {RepositoryFactory} from '@/repository/RepositoryFactory'
import Filter from '@/mixins/filter';
import CreateCustomerProductDetailsPopUp
  from "@/components/popups/customer/product-details/CreateCustomerProductDetailsPopUp";
import UpdateCustomerProductDetailsPopUp
  from "@/components/popups/customer/product-details/UpdateCustomerProductDetailsPopUp";
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import router from "@/router";

const CustomerRepository = RepositoryFactory.get('customer')

export default {
    name: 'CustomerProductDetailsList',
    data () {
      return {
        product_detail_list: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        customerId: ''
      }
    },
    components: {
      'v-select': vSelect,
      CreateCustomerProductDetailsPopUp,
      UpdateCustomerProductDetailsPopUp
    },
    mixins : [Filter, SuccessMessage, ErrorMessages],
    async mounted () {
      this.customerId = this.$route.params.id
    },
    methods: {
      async refreshData () {
        await this.fetchProductDetailList()
      },

      async fetchProductDetailList() {
        await this.$vs.loading({
          container: '#customer-site-list-table',
          scale: 0.45
        })
        this.product_detail_list =  (await CustomerRepository.getCustomerProductDetailsList(this.customerId, this.filterQuery)).data.data
        this.$vs.loading.close('#customer-site-list-table > .con-vs-loading')
      },
      async onClickProductDetailDelete(id) {
        try {
          await CustomerRepository.deleteCustomerProductDetail(id)
          this.showSuccessMessage('Selected product detail removed successfully')
          await this.fetchProductDetailList()
        } catch (e) {
          this.convertAndNotifyError(e)
        }
      },

      async onClickCreateDetail () {
        await this.$refs.createCustomerProductDetailsPopUp.openPopup(this.customerId)
      },
      async onClickCustomerSiteUpdate (id) {
        await this.$refs.updateCustomerProductDetailsPopUp.openPopup(id, this.customerId)
      },

      filterQueryUpdate (){
        this.fetchProductDetailList()
      },

      handleChangePage(page) {
        this.page=page;
        this.fetchProductDetailList()
      },

      viewFormulation(item){
        router.push(`/pages/formulations/${item.id}`)
      }

    },
    watch : {
      page(){
        this.fetchProductDetailList()
      }
    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
</style>
